import { useLifecycles } from 'react-use'

import { match } from 'ts-pattern'

import { GuildDetails } from './components/guild-details'
import { GuildSearch } from './components/guild-search'

import { useAppDispatch } from '~/app/hooks'
import UiSlice from '~/core/slices/ui'
import { P } from '~/core/utils/p'
import { GuildApi } from '~/services/fm/guild'
import CenterCircularProgress from '~/shared/components/center-circular-progress'

export const Page = () => {
  const dispatch = useAppDispatch()
  const { data, isLoading } = GuildApi.getMyGuild.useQuery()

  useLifecycles(
    () => dispatch(UiSlice.actions.setReturnButtonBehavior('Close')),
    () => dispatch(UiSlice.actions.setReturnButtonBehavior('Backup'))
  )

  return match({ isLoading, data })
    .with({ isLoading: true }, () => <CenterCircularProgress />)
    .with({ data: P.valued }, ({ data }) => <GuildDetails info={data} />)
    .otherwise(() => <GuildSearch />)
}
